import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (/* theme */) =>
	({
		root :
		{
			height : '100%',
			width  : '100%'
		}
	});

const LoadingView = ({
	classes
}) =>
{
	return (
		<div className={classes.root} />
		// <div className="loadngCntnr">
		// 	<span className="reTxt textCntr">
		// 		Sit back and relax while we establish your video connection
		// 	</span>
		// 	<div className="loading">
		// 		<div className="dot" />
		// 		<div className="dot" />
		// 		<div className="dot" />
		// 		<div className="dot" />
		// 		<div className="dot" />
		// 	</div>
		// </div>
	);
};

export default withStyles(styles)(LoadingView);
